export default function BannerForm({ form, setForm, onSubmit }) {
    return (
        <form onSubmit={onSubmit}>
            <div className="mb-2">
                <label>Judul Banner</label>
                <input
                    className="form-control"
                    value={form.title}
                    onChange={(e) => setForm({ ...form, title: e.target.value })}
                />
            </div>
            <div className="mb-2">
                <label>Gambar</label>
                <input
                    type="file"
                    accept="image/*"
                    className="form-control"
                    onChange={(e) => setForm({ ...form, image: e.target.files[0] })}
                />
            </div>
            <button className="btn btn-primary">Simpan</button>
        </form>
    );
}
